import accredit from '@/stores/accredit'
import SJButton from '@/components/SJButton'
import SJCard from '@/components/SJCard'
import SJScreenDialog from '@/components/SJScreenDialog'
import { useState, useMemo, useEffect } from 'react'
import { Coupon, OrderAddReq, OrderAddRes } from '@/services/types/payment'
import { orderAdd } from '@/services/payment'
import CouponPicker from '@/components/CouponPicker'
import { Toast } from 'antd-mobile'
import { getImage } from '@/utils/utils'
import images from '@/assets/images'
import { useNavigate } from 'react-router-dom'
import useGetMessageFromR1App from '@/hooks/useGetMessageFromR1App'
import sendMessage from '@/utils/sendMessageToR1App'
import './index.less'

const RegistrationOrder = () => {
  const navigate = useNavigate()
  const result = accredit.applicant_result

  // APP支付成功
  const reciveMessage = useGetMessageFromR1App('PayResult')
  useEffect(() => {
    if (reciveMessage?.status === 1) {
      navigate(`/registration/payResult?orderCode=${reciveMessage.orderCode}&orderStatus=1`)
    }
  }, [reciveMessage])

  // dialog显示
  const [visible, setVisible] = useState(false)
  const [submited, setSubmited] = useState(false)
  const onVisibleChange = (val: boolean) => {
    setVisible(val)
  }
  // 选择优惠券
  const [coupon, setCoupon] = useState<Coupon>()
  const handlePickCoupon = (_coupon?: Coupon) => {
    setVisible(false)
    setCoupon(_coupon)
  }

  const total = useMemo(() => {
    return accredit.applicant_fee - (coupon?.couponAmount || 0)
  }, [coupon])

  const goPay = async () => {
    if (submited) return
    if (!accredit.applicant_result.id) {
      Toast.show('报名信息有误')
      return
    }
    setSubmited(true)
    try {
      const params: OrderAddReq = {
        type: coupon ? 2 : 1, // Y	支付方式（1、现金 2、优惠券 3、混合 优惠券+现金）
        amount: accredit.applicant_fee, // Y	支付金额
        // amount: 0.01, // Y	支付金额
        productList: [
          { productCode: accredit.applicant_code }, // Y	商品编码
        ], // Y	商品列表
        count: 1, // Y	商品数量
        useCouponCode: coupon?.useCouponCode, // N	优惠券编码
        fullAmount: total, // Y	合计金额
        businessCode: String(accredit.applicant_result.id), // 报名id
      }
      console.log(params)
      const res = (await orderAdd(params)) as unknown as OrderAddRes
      if (res.orderCode && !coupon) {
        sendMessage('RouteOrderDetail', { orderCode: res.orderCode, type: 1 })
        // 微信支付
        // const ret = (await orderPaySign(res.orderCode)) as unknown as OrderPaysignRes
        // console.log(ret)
        // Taro.requestPayment({
        //   ...ret,
        //   success: (s) => {
        //     console.log(s)
        //     // Taro.navigateTo({
        //     //   url: `/packageAccredit/pages/payResult/index?orderCode=${res.orderCode}&orderStatus=1`,
        //     // })
        //     Taro.reLaunch({
        //       url: '/packageAccredit/pages/result/index?id=' + accredit.applicant_result.id,
        //     })
        //   },
        //   fail: (err) => {
        //     log.error('requestPayment', err)
        //     Taro.reLaunch({
        //       url: `/packageOrder/pages/orderDetail/index?orderCode=${res.orderCode}`,
        //     })
        //   },
        // })
      } else {
        navigate(`/registration/result?id=${accredit.applicant_result.id}&from=order`)
      }
    } catch (error) {
      setSubmited(false)
    }
  }
  return (
    <div className="page registration-order">
      <div className="main">
        {/* <div className="success">
          <img src={icons.IconSmile} alt="" />
          <span>报名成功，加油备考哦！</span>
        </div> */}
        <SJCard className="section">
          <div className="info-item">
            <div className="label">姓名</div>
            <div className="value name oneline">{result.applicant_name}</div>
          </div>
          <div className="info-item">
            <div className="label">级别</div>
            <div className="value">{result.applying_for_grade}级</div>
          </div>
          <div className="info-item">
            <div className="label">证件号</div>
            <div className="value">{result.identification_num}</div>
          </div>
          <img
            className="photo"
            src={result.applicant_photo ? getImage(result.applicant_photo) : images.avatar_default}
            alt=""
          />
        </SJCard>

        <SJCard className="order-info">
          <div className="order-item">
            <div className="label">报名费用</div>
            <div className="value">¥{accredit.applicant_fee}</div>
          </div>
          <div className="order-item hoverClass" onClick={() => setVisible(true)}>
            <div className="label">优惠券</div>
            <div className="value value-coupon">{`-${coupon?.couponAmount || 0}`}</div>
          </div>
          <div className="order-item">
            <div className="label label-total">总计</div>
            <div className="value">
              ¥<span className="value-total">{total}</span>
            </div>
          </div>
        </SJCard>
      </div>
      <div className="btn-fixed">
        <SJButton type="primary" size="large" onClick={goPay}>
          去支付 ¥{total}
        </SJButton>
      </div>
      <SJScreenDialog title="优惠券" visible={visible} onVisibleChange={onVisibleChange}>
        <div className="coupon-scroll">
          <CouponPicker onCouponChange={handlePickCoupon}></CouponPicker>
        </div>
      </SJScreenDialog>
    </div>
  )
}

export default RegistrationOrder
